import SignupOrgAdmin from "../SignupOrgAdmin";
import SignupSuccess from "../SignupSuccess";
import SignupOrgDetails from "../SignupOrg";

function SignupWizard({ step, setStep }) {
  return (
    <div>
      <div className="signup__nav signup__nav_3 my-12">
        <div
          className={`signup__nav_circle ${step === 1 && "active"} ${
            step > 1 && "active_bg"
          }`}
        >
          1
        </div>

        <div className={`signup__nav_line ${step > 1 && "line_active"}`} />

        <div
          className={`signup__nav_circle ${step === 2 && "active"} ${
            step > 2 && "active_bg"
          }`}
        >
          {step >= 2 && 2}
        </div>

        <div className={`signup__nav_line ${step > 2 && "line_active"}`} />

        <div className={`signup__nav_circle ${step === 3 && "active"}`}>
          {step === 3 && 3}
        </div>
      </div>

      {step === 1 && <SignupOrgAdmin setStep={setStep} />}

      {step === 2 && <SignupOrgDetails setStep={setStep} />}

      {step === 3 && <SignupSuccess />}
    </div>
  );
}

export default SignupWizard;
